module.exports = __webpack_public_path__ + "static/request-d33858a5d1982d2045509923f9ff33c7.jpg";